module.exports = __webpack_public_path__ + "static/img/bg.9f6c49a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bg.gif
// module id = 6xhM
// module chunks = 2